<template>
  <div class="tab-header" :class="[{ 'has-extra': hasExtra }, `tab-header--${titleMode}`]">
    <div class="tab-titles" :class="`tab-titles--${titleMode}`">
      <span
        v-for="(item, i) in items"
        :key="i"
        class="tab-text"
        :class="[{ active: i === currentIndex }, `tab-text--${titleMode}`]"
        @click="handleClick(i)"
      >
        {{ item }}
      </span>
    </div>
    <span class="tab-spacer"></span>
    <div v-if="hasExtra" class="tab-extra">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabHeader',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    activeIndex: {
      type: Number,
      default: 0
    },
    titleMode: {
      type: String,
      default: 'text'
    }
  },
  data() {
    return {
      currentIndex: this.activeIndex
    }
  },
  computed: {
    hasExtra() {
      return Boolean(this.$slots.default)
    }
  },
  watch: {
    activeIndex(val) {
      this.currentIndex = val
    }
  },
  methods: {
    handleClick(i) {
      this.currentIndex = i
      this.$emit('change', i)
    }
  }
}
</script>

<style scoped>
.tab-header {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 0.8vw;
  height: 3.2vh;
  padding: 0 0.56vw 0 3.45vw;
  margin-bottom: 0.3vh;
  box-sizing: border-box;
  background-image: url('~@/assets/tab.png');
  background-position: left center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.tab-titles {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.8vw;
  height: 100%;
  min-width: 0;
  flex: 0 0 auto;
}

.tab-text {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  line-height: 1;
  color: #7bafc8;
  font-size: 0.78vw;
  font-weight: 600;
  letter-spacing: 0.08vw;
  cursor: pointer;
  white-space: nowrap;
}

.tab-text.active {
  color: #e6f8ff;
  text-shadow: 0 0 0.52vw rgba(127, 220, 255, 0.24);
}

.tab-titles--switch {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
  gap: 0;
  padding: 0.12vw;
  border: 0.05vw solid rgba(56, 177, 255, 0.32);
  border-radius: 0.7vw;
  box-sizing: border-box;
  background:
    linear-gradient(180deg, rgba(14, 86, 170, 0.5), rgba(6, 34, 90, 0.5)),
    rgba(4, 21, 62, 0.62);
  box-shadow:
    inset 0 0 0.88vw rgba(24, 162, 255, 0.12),
    0 0 0.68vw rgba(18, 132, 218, 0.12);
}

.tab-text--switch {
  position: relative;
  min-width: 4.86vw;
  height: 2.32vh;
  padding: 0 0.9vw;
  border: 0.05vw solid transparent;
  border-radius: 0.46vw;
  box-sizing: border-box;
  color: rgba(214, 242, 255, 0.78);
  font-size: 0.7vw;
  font-weight: 600;
  letter-spacing: 0.03vw;
  background: transparent;
  box-shadow: none;
  transition: color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.tab-text--switch::before,
.tab-text--switch::after {
  content: '';
  position: absolute;
  top: 50%;
  width: 0.12vw;
  height: 0.9vh;
  border-radius: 999vw;
  background: rgba(25, 209, 255, 0.9);
  opacity: 0;
  transform: translateY(-50%);
}

.tab-text--switch::before {
  left: 0.16vw;
}

.tab-text--switch::after {
  right: 0.16vw;
}

.tab-text--switch.active {
  color: #f6feff;
  border-color: rgba(91, 230, 255, 0.5);
  background:
    linear-gradient(180deg, rgba(17, 205, 255, 0.34), rgba(12, 92, 214, 0.22)),
    linear-gradient(180deg, rgba(8, 77, 157, 0.96), rgba(4, 41, 109, 0.84));
  box-shadow:
    inset 0 0 0 0.06vw rgba(125, 244, 255, 0.34),
    0 0 0.84vw rgba(31, 192, 255, 0.2);
  text-shadow: none;
}

.tab-text--switch.active::before,
.tab-text--switch.active::after {
  opacity: 1;
}

.tab-spacer {
  flex: 1 1 auto;
  min-width: 0;
}

.tab-extra {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  flex: 0 0 auto;
  min-width: max-content;
  gap: 0;
}

.tab-extra :deep(.tab-switch-group),
.tab-extra :deep(.pie-tabs),
.tab-extra :deep(.table-tabs),
.tab-extra :deep(.grain-tab-group) {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
  gap: 0;
  margin: 0;
  padding: 0.12vw;
  border: 0.05vw solid rgba(56, 177, 255, 0.32);
  border-radius: 0.7vw;
  box-sizing: border-box;
  background:
    linear-gradient(180deg, rgba(14, 86, 170, 0.5), rgba(6, 34, 90, 0.5)),
    rgba(4, 21, 62, 0.62);
  box-shadow:
    inset 0 0 0.88vw rgba(24, 162, 255, 0.12),
    0 0 0.68vw rgba(18, 132, 218, 0.12);
}

.tab-extra :deep(.tab-switch-group .tab-btn),
.tab-extra :deep(.tab-btn),
.tab-extra :deep(.table-tab) {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 3.7vw;
  height: 2.32vh;
  padding: 0 0.68vw;
  border: 0.05vw solid transparent;
  border-radius: 0.46vw;
  box-sizing: border-box;
  color: rgba(214, 242, 255, 0.78);
  font-size: 0.6vw;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: transparent;
  box-shadow: none;
  transition: color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.tab-extra :deep(.tab-switch-group .tab-btn::before),
.tab-extra :deep(.tab-switch-group .tab-btn::after),
.tab-extra :deep(.tab-btn::before),
.tab-extra :deep(.tab-btn::after),
.tab-extra :deep(.table-tab::before),
.tab-extra :deep(.table-tab::after) {
  content: '';
  position: absolute;
  top: 50%;
  width: 0.12vw;
  height: 0.9vh;
  border-radius: 999vw;
  background: rgba(25, 209, 255, 0.9);
  opacity: 0;
  transform: translateY(-50%);
}

.tab-extra :deep(.tab-switch-group .tab-btn::before),
.tab-extra :deep(.tab-btn::before),
.tab-extra :deep(.table-tab::before) {
  left: 0.16vw;
}

.tab-extra :deep(.tab-switch-group .tab-btn::after),
.tab-extra :deep(.tab-btn::after),
.tab-extra :deep(.table-tab::after) {
  right: 0.16vw;
}

.tab-extra :deep(.tab-switch-group .tab-btn.active),
.tab-extra :deep(.tab-btn.active),
.tab-extra :deep(.table-tab.active) {
  color: #f6feff;
  border-color: rgba(91, 230, 255, 0.5);
  background:
    linear-gradient(180deg, rgba(17, 205, 255, 0.34), rgba(12, 92, 214, 0.22)),
    linear-gradient(180deg, rgba(8, 77, 157, 0.96), rgba(4, 41, 109, 0.84));
  box-shadow:
    inset 0 0 0 0.06vw rgba(125, 244, 255, 0.34),
    0 0 0.84vw rgba(31, 192, 255, 0.16);
}

.tab-extra :deep(.tab-switch-group .tab-btn.active::before),
.tab-extra :deep(.tab-switch-group .tab-btn.active::after),
.tab-extra :deep(.tab-btn.active::before),
.tab-extra :deep(.tab-btn.active::after),
.tab-extra :deep(.table-tab.active::before),
.tab-extra :deep(.table-tab.active::after) {
  opacity: 1;
}
</style>
